<template>
  <div>
    <!-- DIALOG FULL SCREEN FOR VISOR PREGUNTAS -->
    <v-dialog v-model="VisorSomosHabiles" fullscreen hide-overlay persistent>
      <!-- VISOR PREGUNTAS INTERNO -->
      <template>
        <v-card v-if="showAlertaResult" class="bg">
          <div>
            <v-system-bar height="30" dark window color="primary">
              <v-icon>mdi-comment-question-outline</v-icon>
              <span>VISOR SOMOS HÁBILES </span>
              <v-spacer></v-spacer>
              <v-icon @click="$emit('close')">mdi-minus</v-icon>
              <v-icon @click="maximizarOrmin()">mdi-checkbox-blank-outline</v-icon>
              <v-icon @click="$emit('close')">mdi-close</v-icon>
              <!-- <v-icon @click="VisorSomosHabiles = false">mdi-close</v-icon> -->
            </v-system-bar>
          </div>
          <v-window v-model="step">
            <v-window-item v-for="(respta, i) in arrayPreguntasYrespuestas" :value="i + 1" :key="i">
              <v-card-text>
                <br />
                <v-row justify="end" align-content="end">
                  <v-col cols="4" style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      ">
                    <h2>
                      <v-icon size="40" color="orange">mdi-comment-question-outline</v-icon>
                      Pregunta {{ i + 1 }}
                    </h2>
                  </v-col>
                  <v-col cols="4" style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      ">
                    <!-- <h1>EXAMEN</h1> -->
                  </v-col>
                  <v-col cols="4" style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      ">
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="8" offset="2" class="pb-0">
                    <div class="pb-0 text-center">
                      <h1 class="pt-2 mb-0" v-html="respta.pregunta"></h1>
                      <!-- <h2 class="text-center">
                              {{ respta.pregunta }}
                            </h2> -->
                    </div>
                  </v-col>
                  <v-col cols="8" offset="2" class="py-0">
                    <v-radio-group v-model="radioGroup">
                      <v-alert v-for="(resptar, n) of respta.respuestas" :key="n" v-model="alertRespuestaLive[n]"
                        color="blue" :style="resptar.valor_respuesta ? 'background:#4eff4e;' : ''
                          " border="left" elevation="3" dense colored-border>
                        <v-radio :disabled="true" @change="validaRespuesta(resptar, respta, i)"
                          :value="resptar.valor_respuesta ? 1 : 0">

                          <template v-slot:label>
                            <div style="padding:10px" v-html="resptar.respuesta"></div>
                          </template>

                        </v-radio>
                      </v-alert>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-window-item>
          </v-window>

          <v-card-actions>
            <v-row>
              <v-col cols="2" class="text-center">
                <v-btn :disabled="step === 1" color="success" depressed @click="prevpageSimulador">
                  <v-icon>mdi-step-backward</v-icon>

                  Anterior
                </v-btn>
              </v-col>
              <v-col cols="8" class="text-center align-self-center">
                <v-progress-linear disabled v-model="cantPreguntas" height="20" rounded>
                  <strong>{{ Math.ceil(cantPreguntas) }}%</strong>
                </v-progress-linear>
              </v-col>
              <v-col cols="2" class="text-center">
                <v-btn v-if="step !== contadorPreguntas" :disabled="step === contadorPreguntas" color="primary"
                  depressed @click="nextpageSimulador">
                  Siguiente
                  <v-icon>mdi-step-forward</v-icon>
                </v-btn>
                <v-btn v-else color="error" depressed @click="VisorSomosHabiles = false">
                  Cerrar Muestra
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>

        <v-card v-else color="amber lighten-5">
          <div>
            <v-system-bar height="30" dark window color="primary">
              <v-icon>mdi-comment-question-outline</v-icon>
              <span>VISOR SOMOS HÁBILES </span>
              <v-spacer></v-spacer>
              <v-icon @click="$emit('close')">mdi-minus</v-icon>
              <v-icon @click="maximizarOrmin()">mdi-checkbox-blank-outline</v-icon>
              <v-icon @click="$emit('close')">mdi-close</v-icon>
              <!-- <v-icon @click="VisorSomosHabiles = false">mdi-close</v-icon> -->
            </v-system-bar>
          </div>
          <v-card-title>
            <v-img :src="imgWinOrLose"> </v-img>
          </v-card-title>

          <v-card-text color="orange lighten-2" class="text-h5 orange--text text-center font-weight-bold">
            {{ congratulationOrLose }}
          </v-card-text>

          <v-card-actions>
            <v-list-item class="grow">
              <v-list-item-avatar color="grey darken-3">
                <v-img class="elevation-6" alt=""
                  src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>Puntaje</v-list-item-title>
              </v-list-item-content>

              <div class="d-flex align-center justify-center">
                <span class="subheading mr-2"><strong>{{ aciertos }} </strong></span>
                <v-icon class="mr-1" color="green"> mdi-check </v-icon>
                <span class="mr-6">·</span>
                <span class="subheading"><strong>{{ desaciertos }} </strong></span>
                <v-icon class="mr-1" color="red"> mdi-close </v-icon>
              </div>
            </v-list-item>
          </v-card-actions>

          <br />
          <div style="display: block; text-align: center">
            <v-btn @click="VisorSomosHabiles = false" color="red" class="ma-2 white--text">
              CERRAR
              <v-icon right dark> mdi-close </v-icon>
            </v-btn>
          </div>
          <br /><br />
        </v-card>
      </template>
    </v-dialog>

    <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @close="CloseModal">
    </component>
  </div>
</template>

<script>
// import NProgress from "nprogress";
// import "nprogress/nprogress.css";
import axios from "@/helpers/axios";
//   import { mapState } from "vuex";
export default {
  name: "visorSomosHabiles",
  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
  },
  components: {
    //   chipSimulador: () => import("../components/Co-chipSimulador.vue"),
    //   confirmButton: () => import("../components/Co-ComfirMensaje.vue"),
  },
  data: () => ({
    cantPreguntas: 0,
    step: 1,
    contadorPreguntas: null,
    radioGroup: 1,
    alertRespuestaLive: [], //LOGICA RESPUESTA DE SIMULADOR
    compName: null,
    estadoComponente: true,
    parametroComp: [],
    VisorSomosHabiles: true,

    showAlertaResult: true,
    arrayPreguntasYrespuestas: [],
  }),
  methods: {
    maximizarOrmin() {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else {
        document.documentElement.requestFullscreen();
      }
    },

    nextpageSimulador() {
      const me = this;

      console.log(me.radioGroup);

      me.step++;
      me.cantPreguntas = me.totalPag * me.step;
    },
    prevpageSimulador() {
      const me = this;
      me.step--;

      if (me.step == 1) {
        me.cantPreguntas = me.totalPag * 0;
      } else {
        me.cantPreguntas = me.totalPag * me.step;
      }
    },

    async listarRespuestasPreguntas() {
      const me = this;
      document.documentElement.requestFullscreen();
      // me.idexamenFull = idexamen; event, idexamen, idusuario
      me.cantPreguntas = 0;
      me.arrayPreguntasYrespuestas = [];
      me.contadorPreguntas = null;
      me.totalPag = null;
      try {
        const response = await axios.get(
          `/simulador/simuladorExamen/simuladorDetalles/simuladorDE/listarPdetalle/${this.parametros.items.muestra[0].idusuario}/lista/${this.parametros.items.muestra[0].idexamen}`
        );

        const datosRespuestas = response.data.map((number) => {
          return {
            idexamen: number.idexamen,
            idpregunta: number.idpregunta,
            pregunta: number.pregunta,
            respuestas: number.respuestas,
          };
        });

        me.arrayPreguntasYrespuestas = datosRespuestas;
        let contadorPag = datosRespuestas.length;
        me.contadorPreguntas = contadorPag;
        me.totalPag = 100 / contadorPag;
        me.VisorSomosHabiles = true;

        // setTimeout(async () => {
        //   NProgress.done();
        //   me.VisorSomosHabiles = true;
        //   document.documentElement.requestFullscreen();
        // }, 800);
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },

    closeLocal() {
      this.$emit("close");
    },
    CloseModal() {
      this.VisorSomosHabiles = true;
      this.estadoComponente = false;
    },
    init() {
      this.listarRespuestasPreguntas();
      // console.log(this.parametros.items.muestra[0].idexamen);
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    estadoComp() {
      if (this.estadoComp) {
        this.VisorSomosHabiles = true;
        this.listarRespuestasPreguntas();
      } else {
        this.VisorSomosHabiles = false;
      }
    },
    VisorSomosHabiles(e) {
      const me = this;
      if (!e) {
        me.arrayPreguntasYrespuestas = [];
        if (document.fullscreenElement) {
          document.exitFullscreen();
        }
        this.$emit("close");
        me.showAlertaResult = true;
      }
    },
  },
};
</script>

<style></style>
